import styled from 'styled-components';

// margin-top: 50px;
export const LargeField = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    gap: 12px;
    width: 304px;
    height: 530px;
    background: linear-gradient(339.68deg, rgba(239, 239, 239, 0.6) 4.62%, rgba(255, 255, 255, 0.45) 93.97%);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    flex: none;
    order: 1;
    flex-grow: 0;
    backdrop-filter: blur(10px);
`;